import { useLocation } from "react-router-dom";
import styles from "./ResetPassword.module.scss";
import LanguagePicker from "../../components/LanguagePicker/LanguagePicker";
import logo from "../../assets/logo.png";
import ResetPasswordForm from "../../components/ResetPasswordForm/ResetPasswordForm";

const ResetPassword = () => {
  const location = useLocation();
  const email = location.state?.email || "";

  return (
    <div className={styles.root}>
      <div className={styles.root_border}>
        <LanguagePicker border={true} />
      </div>
      <div className={styles.root_form}>
        <img className={styles.root_logo} src={logo} alt="Fortect logo" />
        <ResetPasswordForm email={email} isForgotPasswordPage={true} />
      </div>
    </div>
  );
};

export default ResetPassword;
